





















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Viewpoints from '@/store/modules/Viewpoints';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import FactorNavigation from '@/components/navigation/FactorNavigation.vue';
import Dialogs from '@/store/modules/Dialogs';
import { FactorGroup } from '@/api/model/FactorResource';
import Modelling from '@/store/modules/Modelling';
import Decisions from '@/store/modules/Decisions';
import FactorGroupScoringDefinition from '@/components/scoring-definition/FactorGroupScoringDefinition.vue';

const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const viewpointsModule = getModule(Viewpoints);
const workspaceOptionsModule = getModule(WorkspaceOptions);
@Component({
    components: {
        FactorNavigationTree: FactorNavigation,
        FactorGroupScoringDefinition,
    },
})
export default class FactorNavigationWorkingModel extends Vue {
    @Prop({ default: null, type: String })
    search!: string | null;

    @Prop({ default: false, type: Boolean })
    openAll!: boolean;

    @Prop({ default: false, type: Boolean })
    menuVisible!: boolean;

    @Prop({ default: false, type: Boolean })
    menuEdit!: boolean;

    @Prop({ default: false, type: Boolean })
    menuNew!: boolean;

    @Prop({ default: false, type: Boolean })
    menuFolderToggle!: boolean;

    @Prop({ default: '', type: String })
    clickUrl!: string;

    @Prop({ default: 'Select a Factor', type: String })
    header!: string;

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get factorResources() {
        return modellingModule.workingModelFactorResources;
    }

    get factorResourceTree() {
        if (this.factorResources && this.factorResources['M']) {
            return this.getSubTree('M');
        }
    }

    private getSubTree(
        factorResourceId: string
    ): { id: string; name?: string; children: any[] } {
        let factorGroup = this.factorResources[factorResourceId] as FactorGroup;
        let childrenIds: any[];
        if (
            factorGroup.groupTypeDefinition &&
            (
                factorGroup.groupTypeDefinition.type === 'TABLE_FIXED'
                // TODO - Temp off to hide row/cols of Fixed Tables (Dion 2021-01-27)
                // || factorGroup.groupTypeDefinition.type === 'TABLE_GROWING'
            )
        ) {
            /*
            childrenIds = factorGroup.childrenIds
                .map((f) => this.factorResources[f])
                .filter((f) => f)
                .filter(
                    (f) =>
                        f.type === 'FACTOR_GROUP' &&
                        (f as FactorGroup).groupTypeDefinition.type ===
                            'TABLE_COLUMN'
                )
                .map((f) => f.id);
            // This will update the factor names to display correctly
            let rows = factorGroup.childrenIds
                .map((f) => this.factorResources[f])
                .filter((f) => f)
                .filter(
                    (f) =>
                        f.type === 'FACTOR_GROUP' &&
                        (f as FactorGroup).groupTypeDefinition.type ===
                            'TABLE_ROW'
                ) as FactorGroup[];
            for (let colId of childrenIds) {
                let column = this.factorResources[colId] as FactorGroup;
                if (!column) continue;
                column.childrenIds.forEach((id) => {
                    let row = rows.find((r) => r.childrenIds.includes(id));
                    if (row && this.factorResources[id]) {
                        this.factorResources[id].name = row.name;
                    }
                });
            }
            */
        } else {
            childrenIds = factorGroup.childrenIds || [];
        }
        if (!childrenIds) { childrenIds = []; }
        let children = childrenIds
            .filter((f) => this.factorResources[f])
            .map((cId) => {
                let resource = this.factorResources[cId];
                if (resource.type === 'FACTOR') {
                    return {
                        id: cId,
                        name: resource.name,
                    };
                }
                return this.getSubTree(cId);
            });

        return {
            id: factorResourceId,
            name: factorGroup.name,
            children: children,
        };
    }

    get selectionPath() {
        return workspaceOptionsModule.draftSelectionPath;
    }

    get selectedFactorResourceItemId() {
        return workspaceOptionsModule.draftSelectedPathItemId;
    }

    private selectFactorResource(itemId: string) {
        if (itemId) {
            workspaceOptionsModule.selectDraftSelectionPathItem(itemId);
            workspaceOptionsModule.updateDraftExpansions(itemId);
            if (this.clickUrl) {
                if (this.$route.path !== this.clickUrl) {
                    this.$router.push(this.clickUrl);
                }
            }
        }
    }

    private editScoringDefinition(factorId: string) {
        getModule(Dialogs).editDecisionModelResourceScoringDefinition(factorId);
    }

    private editScoringKeyDefinition(factorGroupId: string) {
        getModule(Dialogs).editDecisionModelResourceScoringKey(factorGroupId);
    }

    // get the correct factor resource and update
    private async submitFactorScoringSum(item, scoringDefinition) {
        const factorResource = this.factorResources[item.id];
        if (factorResource) {
            factorResource.summaryScoringFunction =
                scoringDefinition.summaryScoringFunction;
            await modellingModule.updateFactorResource(factorResource);
        }
    }

    private hasSummaryScoringFunction(item) {
        return (
            this.factorResources[item.id].hasOwnProperty(
                'summaryScoringFunction'
            ) && this.factorResources[item.id].summaryScoringFunction
        );
    }
}
